import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

export const cases = createReducer({},{
  [types.SET_CASES](state,action){
    return action.payload;
  }
})

export const currentCase = createReducer(null,{
  [types.SET_CURRENT_CASE](state,action){
    return action.payload;
  }
})

export const currentSelection = createReducer({},{
  [types.SET_CURRENT_SELECTION](state,action){
    return action.payload;
  }
})



// WEBPACK FOOTER //
// ./src/reducers/cases.js